export function Do<T>(value: T, action: ((x: T) => void)): T {
    if (value !== null && value !== undefined) {
        action(value);
    }
    return value;
}
